export default __webpack_public_path__ + "static/media/ARC Platform - Left side placeholder image for home page.79b830cc.png";